var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 130,
    viewBox: "0 0 160 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "designer-girl/rafiki"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M79.9999 130.001C114.266 130.001 142.045 128.232 142.045 126.05C142.045 123.869 114.266 122.1 79.9999 122.1C45.7335 122.1 17.9551 123.869 17.9551 126.05C17.9551 128.232 45.7335 130.001 79.9999 130.001Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "background-complete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M160 114.245H0V114.332H160V114.245Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.2429 119.86H32.6445V119.947H43.2429V119.86Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M68.6997 117.22H54.7637V117.307H68.6997V117.22Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.3263 116.62H16.7871V116.707H32.3263V116.62Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M90.2072 117.803H79.2344V117.89H90.2072V117.803Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M108.599 117.803H93.0566V117.89H108.599V117.803Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M134.495 119.277H104.518V119.364H134.495V119.277Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M75.8394 98.6835H14.0506C13.5665 98.6826 13.1026 98.4723 12.7606 98.0987C12.4186 97.7252 12.2266 97.2189 12.2266 96.6911V1.97721C12.2308 1.4524 12.4247 0.950604 12.7662 0.580807C13.1077 0.21101 13.5693 0.00308102 14.0506 0.00218201H75.8394C76.324 0.00218201 76.7887 0.212102 77.1314 0.585763C77.4741 0.959424 77.6666 1.46622 77.6666 1.99465V96.6911C77.6666 97.2195 77.4741 97.7263 77.1314 98.1C76.7887 98.4736 76.324 98.6835 75.8394 98.6835ZM14.0506 0.0719711C13.5877 0.0728954 13.1441 0.274032 12.8172 0.631233C12.4902 0.988433 12.3066 1.47251 12.3066 1.97721V96.6911C12.3066 97.1958 12.4902 97.6799 12.8172 98.0371C13.1441 98.3943 13.5877 98.5954 14.0506 98.5963H75.8394C76.3022 98.5945 76.7457 98.3932 77.073 98.0363C77.4003 97.6794 77.5849 97.1958 77.5866 96.6911V1.97721C77.5849 1.47247 77.4003 0.988936 77.073 0.632033C76.7457 0.27513 76.3022 0.0738098 75.8394 0.0719711H14.0506Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M145.061 98.6835H83.2686C82.7845 98.6817 82.3207 98.4712 81.9784 98.0979C81.6361 97.7247 81.4431 97.219 81.4414 96.6911V1.97721C81.4465 1.45208 81.6411 0.95029 81.9831 0.580589C82.3252 0.210888 82.787 0.00307122 83.2686 0.00218201H145.061C145.541 0.00399808 146.002 0.212333 146.343 0.582032C146.684 0.951731 146.877 1.453 146.881 1.97721V96.6911C146.882 96.9523 146.835 97.211 146.744 97.4525C146.653 97.694 146.519 97.9135 146.349 98.0985C146.18 98.2835 145.98 98.4304 145.758 98.5308C145.537 98.6312 145.3 98.6831 145.061 98.6835ZM83.2686 0.0719711C82.8057 0.0738098 82.3623 0.27513 82.035 0.632033C81.7077 0.988936 81.5231 1.47247 81.5214 1.97721V96.6911C81.5231 97.1958 81.7077 97.6794 82.035 98.0363C82.3623 98.3932 82.8057 98.5945 83.2686 98.5963H145.061C145.523 98.5945 145.967 98.3932 146.294 98.0363C146.622 97.6794 146.806 97.1958 146.808 96.6911V1.97721C146.806 1.47247 146.622 0.988936 146.294 0.632033C145.967 0.27513 145.523 0.0738098 145.061 0.0719711H83.2686Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M70.4075 34.6281H39.1211V114.243H70.4075V34.6281Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M65.6692 34.6281H34.3828V114.243H65.6692V34.6281Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M62.874 95.2454H37.418V109.657H62.874V95.2454Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M62.874 76.3433H37.418V90.7582H62.874V76.3433Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M62.874 57.4412H37.418V71.8561H62.874V57.4412Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M62.874 38.548H37.418V52.9629H62.874V38.548Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.05,
    d: "M42.7364 38.548H37.418V52.9629H42.7364V38.548Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.05,
    d: "M42.7364 57.4412H37.418V71.8561H42.7364V57.4412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    opacity: 0.05,
    d: "M42.7364 76.3433H37.418V90.7582H42.7364V76.3433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.05,
    d: "M42.7364 95.2454H37.418V109.657H42.7364V95.2454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M41.5512 8.29227H19.1992V32.666H41.5512V8.29227Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M40.3813 8.29227H18.0293V32.666H40.3813V8.29227Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M37.8112 11.0998H20.6016V29.866H37.8112V11.0998Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M21.1712 11.0998H20.6016V29.866H21.1712V11.0998Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M31.8061 23.1459C33.1553 21.7121 33.1832 19.3571 31.8684 17.8858C30.5535 16.4146 28.3938 16.3841 27.0446 17.8179C25.6953 19.2517 25.6675 21.6067 26.9823 23.078C28.2971 24.5493 30.4568 24.5797 31.8061 23.1459Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M17.9706 108.349C17.9706 108.349 16.2074 106.691 14.9882 102.898C13.769 99.1053 10.9434 94.7575 10.9434 94.7575C10.9434 94.7575 14.6394 96.6627 15.9418 100.288C15.9418 100.288 14.3418 92.9395 10.9434 90.2526C10.9434 90.2526 17.0234 92.3881 18.5498 99.3007C18.5498 99.3007 19.5642 93.8118 17.9098 88.3578C17.9098 88.3578 21.0234 92.6254 21.3882 97.9189C21.3882 97.9189 21.8202 88.7521 24.5882 86.0548C24.5882 86.0548 23.7178 94.3527 24.5882 98.54C24.5882 98.54 25.8202 91.1913 31.3274 90.1654C31.3274 90.1654 27.7754 94.8273 27.9226 98.9343C28.5421 97.5156 29.4889 96.2967 30.6702 95.3969C31.8516 94.4971 33.227 93.9473 34.6618 93.8014C34.6618 93.8014 30.7194 96.8128 30.3642 101.712C30.009 106.611 29.9994 108.112 27.609 108.823C25.2186 109.535 17.9706 108.349 17.9706 108.349Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M14.1484 103.862V113.409C14.1484 113.409 15.2748 116.829 22.51 117.269C29.7452 117.708 31.4348 113.496 31.4348 113.496V103.862H14.1484Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M142.592 76.8642H97.2637V114.533H142.592V76.8642Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M131.305 76.8642H85.9766V114.533H131.305V76.8642Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M129.05 80.3515H87.5977V94.3058H129.05V80.3515Z",
    stroke: "#E0E0E0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M129.05 96.6315H87.5977V110.586H129.05V96.6315Z",
    stroke: "#E0E0E0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M108.322 88.597C108.963 88.597 109.483 88.0299 109.483 87.3303C109.483 86.6307 108.963 86.0636 108.322 86.0636C107.68 86.0636 107.16 86.6307 107.16 87.3303C107.16 88.0299 107.68 88.597 108.322 88.597Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M108.322 105.936C108.963 105.936 109.483 105.369 109.483 104.67C109.483 103.97 108.963 103.403 108.322 103.403C107.68 103.403 107.16 103.97 107.16 104.67C107.16 105.369 107.68 105.936 108.322 105.936Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M144.278 74.8601H83.9805V76.87H144.278V74.8601Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    opacity: 0.05,
    d: "M144.276 74.8601H133.016V76.87H144.276V74.8601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M143.625 18.6747H93.4238V49.6261H143.625V18.6747Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M142.313 18.6747H92.1113V49.6261H142.313V18.6747Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M140.202 21.0143H94.0703V47.4398H140.202V21.0143Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M94.5727 21.0143H94.0703V47.4398H94.5727V21.0143Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M137.753 29.3883L131.92 27.0001L130.13 32.1975L135.963 34.5857L137.753 29.3883Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M132.358 28.3027C132.479 28.3027 132.578 28.1949 132.578 28.062C132.578 27.929 132.479 27.8212 132.358 27.8212C132.236 27.8212 132.137 27.929 132.137 28.062C132.137 28.1949 132.236 28.3027 132.358 28.3027Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M109.696 36.1996L122.106 37.5604L121.347 42.9412L109.398 41.3814L109.696 36.1996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M121.455 38.5504C121.455 38.598 121.442 38.6445 121.418 38.6841C121.394 38.7237 121.359 38.7546 121.319 38.7728C121.279 38.791 121.234 38.7958 121.191 38.7865C121.149 38.7772 121.109 38.7543 121.078 38.7206C121.047 38.687 121.026 38.6441 121.018 38.5973C121.009 38.5506 121.014 38.5022 121.03 38.4582C121.047 38.4142 121.075 38.3766 121.112 38.3502C121.148 38.3237 121.191 38.3096 121.234 38.3096C121.293 38.3096 121.349 38.335 121.391 38.3801C121.432 38.4253 121.455 38.4865 121.455 38.5504Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M116.48 74.8615L119.223 59.5778H132.064L129.396 74.8615H116.48Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M118.436 72.9459L120.49 61.4936H130.112L128.112 72.9459H118.436Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M120.986 61.4936L118.996 72.9459H118.436L120.49 61.4936H120.986Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M132.065 59.5778H132.596L130.113 74.8615H129.396L132.065 59.5778Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M131.686 65.1486L133.507 74.8562H130.111L131.686 65.1486Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M103.745 15.7948V57.5948C103.746 58.2738 103.623 58.9462 103.385 59.5736C103.147 60.201 102.798 60.7711 102.358 61.2513C101.918 61.7316 101.396 62.1126 100.82 62.3725C100.245 62.6324 99.6286 62.7662 99.006 62.7662H95.2012V15.7948H103.745Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    opacity: 0.8,
    d: "M103.745 15.7948V57.5948C103.746 58.2738 103.623 58.9462 103.385 59.5736C103.147 60.201 102.798 60.7711 102.358 61.2513C101.918 61.7316 101.396 62.1126 100.82 62.3725C100.245 62.6324 99.6286 62.7662 99.006 62.7662H95.2012V15.7948H103.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M103.745 12.6231V57.5985C103.745 58.2775 103.623 58.9499 103.385 59.5773C103.147 60.2047 102.798 60.7748 102.358 61.255C101.917 61.7353 101.395 62.1162 100.82 62.3762C100.244 62.6361 99.628 62.7699 99.0053 62.7699H32.0197C30.762 62.7699 29.5557 62.225 28.6664 61.2552C27.777 60.2854 27.2773 58.9701 27.2773 57.5985V12.6231C27.2769 11.9439 27.3993 11.2712 27.6375 10.6436C27.8757 10.016 28.225 9.44571 28.6654 8.96541C29.1059 8.48512 29.6288 8.10422 30.2044 7.84449C30.78 7.58477 31.3968 7.45132 32.0197 7.45178H99.0053C99.628 7.45178 100.244 7.58557 100.82 7.8455C101.395 8.10542 101.917 8.4864 102.358 8.96665C102.798 9.4469 103.147 10.017 103.385 10.6444C103.623 11.2718 103.745 11.9442 103.745 12.6231Z",
    fill: "white",
    stroke: "#0060C7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M103.526 11.0703H27.4941C27.7972 10.0207 28.3993 9.1038 29.2131 8.45302C30.0269 7.80224 31.0098 7.45149 32.0189 7.45178H99.0045C100.013 7.45224 100.995 7.80333 101.808 8.45405C102.622 9.10478 103.223 10.0213 103.526 11.0703Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M36.9396 9.99444C37.3107 9.99444 37.6116 9.66636 37.6116 9.26165C37.6116 8.85695 37.3107 8.52887 36.9396 8.52887C36.5684 8.52887 36.2676 8.85695 36.2676 9.26165C36.2676 9.66636 36.5684 9.99444 36.9396 9.99444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M39.34 9.99444C39.7111 9.99444 40.012 9.66636 40.012 9.26165C40.012 8.85695 39.7111 8.52887 39.34 8.52887C38.9688 8.52887 38.668 8.85695 38.668 9.26165C38.668 9.66636 38.9688 9.99444 39.34 9.99444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M42.409 9.26515C42.409 9.41092 42.3693 9.55341 42.295 9.67456C42.2206 9.79572 42.115 9.89008 41.9914 9.9457C41.8679 10.0013 41.732 10.0157 41.6009 9.98701C41.4698 9.95832 41.3495 9.88784 41.2552 9.78452C41.1609 9.68121 41.0969 9.54969 41.0712 9.40664C41.0455 9.26359 41.0593 9.11544 41.1109 8.98096C41.1625 8.84649 41.2495 8.73174 41.361 8.65126C41.4725 8.57078 41.6033 8.52819 41.737 8.52888C41.8255 8.52888 41.9132 8.54795 41.9949 8.58499C42.0766 8.62203 42.1509 8.67632 42.2133 8.74474C42.2757 8.81315 42.3252 8.89435 42.3588 8.98365C42.3923 9.07296 42.4094 9.16863 42.409 9.26515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M103.744 12.6243V15.7997H27.2637V12.6243C27.2636 12.0977 27.337 11.5741 27.4813 11.0715H103.513C103.662 11.5734 103.74 12.097 103.744 12.6243Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    opacity: 0.5,
    d: "M103.744 12.6243V15.7997H27.2637V12.6243C27.2636 12.0977 27.337 11.5741 27.4813 11.0715H103.513C103.662 11.5734 103.74 12.097 103.744 12.6243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M36.2725 15.7948V62.7662H31.9141C30.8892 62.7754 29.888 62.4297 29.0547 61.7788C28.2214 61.1279 27.5991 60.2054 27.2773 59.1441V15.7948H36.2725Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    opacity: 0.1,
    d: "M36.2725 15.7948V62.7662H31.9141C30.8892 62.7754 29.888 62.4297 29.0547 61.7788C28.2214 61.1279 27.5991 60.2054 27.2773 59.1441V15.7948H36.2725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    opacity: 0.1,
    d: "M92.2006 19.1232H39.3398V58.027H92.2006V19.1232Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    opacity: 0.2,
    d: "M30.9263 21.092H28.6543V23.5695H30.9263V21.092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    opacity: 0.2,
    d: "M34.3657 21.092H32.0938V23.5695H34.3657V21.092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M71.0574 38.4213C72.9934 35.6856 74.2574 32.095 73.995 28.5881C73.7486 25.2975 71.3134 23.2911 68.3566 24.0797C67.1086 24.4287 65.9662 25.0917 64.8142 25.7163C62.8942 26.7631 60.8718 27.6564 58.7342 27.939C56.5966 28.2217 54.4814 27.939 52.3982 28.8289C48.7726 30.3712 47.7646 35.4239 49.163 39.0878C50.4046 42.34 53.3614 44.8524 56.507 45.5503",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    opacity: 0.2,
    d: "M30.9263 25.0208H28.6543V27.4983H30.9263V25.0208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    opacity: 0.2,
    d: "M34.3657 25.0208H32.0938V27.4983H34.3657V25.0208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    opacity: 0.2,
    d: "M30.9263 28.9495H28.6543V31.427H30.9263V28.9495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    opacity: 0.2,
    d: "M34.3657 28.9495H32.0938V31.427H34.3657V28.9495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    opacity: 0.2,
    d: "M30.9263 32.8782H28.6543V35.3557H30.9263V32.8782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    opacity: 0.2,
    d: "M34.3657 32.8782H32.0938V35.3557H34.3657V32.8782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    opacity: 0.2,
    d: "M30.9263 36.7981H28.6543V39.2756H30.9263V36.7981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    opacity: 0.2,
    d: "M34.3657 36.7981H32.0938V39.2756H34.3657V36.7981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    opacity: 0.2,
    d: "M30.9263 40.7269H28.6543V43.2044H30.9263V40.7269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    opacity: 0.2,
    d: "M34.3657 40.7269H32.0938V43.2044H34.3657V40.7269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M30.8543 44.5498C30.8543 44.6059 30.839 44.6606 30.8104 44.7072C30.7818 44.7538 30.7411 44.79 30.6936 44.8113C30.646 44.8325 30.5937 44.8379 30.5434 44.8267C30.493 44.8156 30.4468 44.7883 30.4107 44.7484C30.3746 44.7085 30.3502 44.6578 30.3405 44.6028C30.3309 44.5477 30.3365 44.4908 30.3566 44.4392C30.3767 44.3876 30.4104 44.3437 30.4535 44.3131C30.4965 44.2825 30.5469 44.2665 30.5983 44.2672C30.6322 44.2672 30.6658 44.2745 30.6971 44.2888C30.7283 44.303 30.7567 44.3239 30.7805 44.3502C30.8043 44.3765 30.8231 44.4076 30.8358 44.4419C30.8485 44.4762 30.8548 44.5129 30.8543 44.5498Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M31.784 44.5498C31.784 44.6057 31.7688 44.6604 31.7403 44.7068C31.7119 44.7533 31.6714 44.7896 31.624 44.8109C31.5767 44.8323 31.5245 44.8379 31.4743 44.827C31.424 44.8161 31.3778 44.7892 31.3415 44.7497C31.3053 44.7101 31.2806 44.6598 31.2706 44.605C31.2606 44.5501 31.2657 44.4933 31.2854 44.4417C31.305 44.39 31.3382 44.3459 31.3808 44.3148C31.4234 44.2837 31.4736 44.2672 31.5248 44.2672C31.559 44.2667 31.5929 44.2737 31.6245 44.2877C31.6562 44.3018 31.6849 44.3226 31.7091 44.3489C31.7332 44.3753 31.7523 44.4066 31.7652 44.4411C31.778 44.4756 31.7845 44.5126 31.784 44.5498Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M32.7137 44.5498C32.7137 44.6059 32.6984 44.6606 32.6698 44.7072C32.6412 44.7538 32.6005 44.79 32.553 44.8113C32.5054 44.8325 32.4531 44.8379 32.4028 44.8267C32.3524 44.8156 32.3062 44.7883 32.2701 44.7484C32.234 44.7085 32.2095 44.6578 32.1999 44.6028C32.1903 44.5477 32.1959 44.4908 32.216 44.4392C32.2361 44.3876 32.2698 44.3437 32.3128 44.3131C32.3559 44.2825 32.4063 44.2665 32.4577 44.2672C32.4916 44.2672 32.5252 44.2745 32.5564 44.2888C32.5877 44.303 32.6161 44.3239 32.6399 44.3502C32.6637 44.3765 32.6825 44.4076 32.6952 44.4419C32.7078 44.4762 32.7141 44.5129 32.7137 44.5498Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M64.3508 41.9027L63.9444 42.2133L63.7012 40.2766L65.1828 41.2606L64.8148 41.5328L65.3876 42.454L64.9364 42.8588L64.3508 41.9027Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M95.3929 63.1866C95.3929 63.1866 93.7609 71.7776 92.6569 73.9725C91.5529 76.1673 85.2233 76.0661 85.2233 76.0661L77.8953 75.6683C77.8953 75.6683 76.5001 70.6889 82.4745 73.2711C82.4745 73.2711 87.5145 72.2242 89.4377 70.4795L91.4537 61.4663L95.3929 63.1866Z",
    fill: "#DCACFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M117.203 127.237H115.248L109.942 95.7655L109.76 94.6803L111.648 94.3L111.894 95.7655L117.203 127.237Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    opacity: 0.5,
    d: "M117.203 127.237H115.248L109.942 95.7655L109.76 94.6803L111.648 94.3L111.894 95.7655L117.203 127.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M108.77 127.24H106.841L104.191 95.7687L103.91 92.4188L103.846 91.6756L105.756 91.4836L105.836 92.4188L106.118 95.7687L108.77 127.24Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    opacity: 0.5,
    d: "M108.77 127.24H106.841L104.191 95.7687L103.91 92.4188L103.846 91.6756L105.756 91.4836L105.836 92.4188L106.118 95.7687L108.77 127.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M89.0393 92.8149L88.8345 95.7669L86.6393 127.238H84.7129L86.9049 95.7669L87.1225 92.6578L89.0393 92.8149Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    opacity: 0.5,
    d: "M89.0393 92.8149L88.8345 95.7669L86.6393 127.238H84.7129L86.9049 95.7669L87.1225 92.6578L89.0393 92.8149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M83.4739 92.9027L83.0419 95.7606L78.2835 127.232H76.3379L81.0995 95.7606L81.5827 92.5607L83.4739 92.9027Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    opacity: 0.5,
    d: "M83.4739 92.9027L83.0419 95.7606L78.2835 127.232H76.3379L81.0995 95.7606L81.5827 92.5607L83.4739 92.9027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M114.857 91.9195L114.681 92.4116L113.84 94.732C113.731 95.0364 113.541 95.2978 113.294 95.4816C113.046 95.6654 112.753 95.763 112.454 95.7614H80.7549C80.4473 95.7621 80.147 95.6592 79.895 95.4668C79.643 95.2745 79.4516 95.002 79.3469 94.6867L78.6013 92.4116L78.4253 91.8707C78.3446 91.6254 78.3193 91.3625 78.3514 91.1043C78.3836 90.8461 78.4724 90.6001 78.6102 90.3872C78.748 90.1743 78.9308 90.0007 79.1431 89.8811C79.3555 89.7616 79.5911 89.6995 79.8301 89.7003H113.472C113.715 89.6999 113.954 89.7644 114.168 89.8881C114.383 90.0117 114.567 90.1908 114.704 90.4097C114.84 90.6286 114.926 90.8806 114.952 91.1438C114.979 91.407 114.947 91.6733 114.857 91.9195Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    opacity: 0.3,
    d: "M114.682 92.4106L113.84 94.7311C113.732 95.0355 113.541 95.2969 113.294 95.4807C113.047 95.6645 112.754 95.7621 112.454 95.7605H80.7552C80.4476 95.7612 80.1473 95.6583 79.8953 95.4659C79.6433 95.2736 79.4519 95.0011 79.3472 94.6858L78.6016 92.4106H114.682Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M82.5769 112.479L84.0745 108.77C84.1614 108.554 84.3174 108.379 84.5134 108.279C84.7095 108.179 84.9322 108.16 85.1401 108.226L87.5081 108.958C87.632 108.997 87.7467 109.064 87.8447 109.156C87.9426 109.247 88.0214 109.36 88.0757 109.488C88.13 109.615 88.1586 109.754 88.1595 109.894C88.1604 110.035 88.1336 110.174 88.0809 110.302C87.4409 111.879 86.2249 114.817 85.8409 115.868C85.3193 117.33 84.8809 119.092 84.1833 119.584C84.1406 119.615 84.0957 119.641 84.0489 119.664C83.902 119.73 83.7415 119.752 83.5843 119.727C83.4271 119.702 83.2789 119.631 83.1552 119.522C83.0316 119.414 82.937 119.271 82.8815 119.108C82.8259 118.946 82.8113 118.77 82.8393 118.6C83.0249 117.372 83.2265 115.075 82.5481 113.223C82.5068 113.103 82.488 112.975 82.493 112.848C82.4979 112.72 82.5265 112.595 82.5769 112.479Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M95.5101 77.2209C95.5101 77.2209 79.3341 74.8132 74.4477 79.8241C74.4477 79.8241 71.4205 84.3289 72.8765 93.1467C73.8288 98.5887 75.8974 103.725 78.9277 108.172L83.1741 104.236C83.1741 104.236 79.3949 94.0854 80.6749 87.8044L86.5501 87.4241L94.9757 81.1431L95.8589 78.5399L95.5101 77.2209Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M79.3184 109.946L77.7344 107.849L83.5392 102.643L84.6368 103.889L79.3184 109.946Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M111.41 77.0287C111.41 77.0287 111.858 82.0535 110.396 85.7313C108.933 89.4092 103.765 90.7561 100.281 90.5119C96.7959 90.2676 92.2999 89.9536 90.3895 90.5398C90.3895 90.5398 87.9159 105.834 83.6439 116.986L78.4727 116.498C78.4727 116.498 81.2823 94.9121 81.7335 89.8977C82.1847 84.8834 81.9575 84.1367 84.7671 81.6871C87.5767 79.2375 101.967 75.926 111.41 77.0287Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M82.3296 119.005L81.84 121.34L77.7344 122.907L78.928 117.934L82.3296 119.005Z",
    fill: "#DCACFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M77.6784 122.763L81.1664 121.349C81.3696 121.268 81.593 121.269 81.7954 121.353C81.9978 121.437 82.1654 121.598 82.2672 121.807L83.432 124.169C83.4953 124.293 83.5329 124.431 83.5422 124.573C83.5516 124.715 83.5324 124.857 83.4861 124.99C83.4398 125.123 83.3674 125.243 83.2741 125.342C83.1807 125.442 83.0686 125.518 82.9456 125.565C81.4576 126.154 78.6832 127.257 77.7328 127.697C76.408 128.311 74.9424 129.194 74.1328 128.988C74.0829 128.976 74.0337 128.961 73.9856 128.942C73.8398 128.873 73.7139 128.762 73.6208 128.621C73.5278 128.48 73.4711 128.315 73.4568 128.142C73.4424 127.969 73.4708 127.795 73.5391 127.638C73.6073 127.481 73.7129 127.347 73.8448 127.25C74.7824 126.552 76.4336 125.101 77.1792 123.279C77.226 123.161 77.2944 123.054 77.3802 122.965C77.4661 122.876 77.5675 122.807 77.6784 122.763Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M95.3938 78.3774C95.3938 78.3774 93.2882 63.1913 92.8338 59.496C92.3794 55.8007 92.8338 53.9129 94.1138 52.7021C95.3938 51.4912 101.263 48.9056 105.202 49.6034C109.141 50.3013 111.064 53.8989 111.602 57.9781L110.687 58.4771C110.687 58.4771 111.858 72.6303 111.432 77.526L95.3938 78.3774Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M94.1136 52.6907C94.1136 52.6907 91 55.6881 91 61.4806L95.8544 63.5079L94.1136 52.6907Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M110.762 58.4204C110.762 58.4204 112.526 65.2179 112.042 68.0269C111.559 70.8359 107.172 74.6045 101.073 75.8606C101.073 75.8606 98.3625 76.3771 96.8009 74.9743L94.4297 74.2346L95.1081 71.942C96.9153 71.9769 98.6947 72.4326 100.327 73.2785C100.327 73.2785 106.154 70.3962 107.985 68.1804C107.985 68.1804 107.78 63.672 106.766 60.5036L110.762 58.4204Z",
    fill: "#DCACFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M84.3653 116.985L77.5589 115.868L77.3125 118.203L83.4885 119.578L84.3653 116.985Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M90.702 43.3292C90.2804 44.6705 90.3329 46.1349 90.8492 47.4363C90.6094 46.3983 90.6539 45.3064 90.9772 44.2958C91.2972 43.3397 91.8252 42.4987 92.2348 41.5914C92.6444 40.6842 92.9228 39.6269 92.6508 38.6603C92.5932 38.4684 92.4652 38.2451 92.2828 38.2765C92.1004 38.3079 92.062 38.4754 92.0108 38.6254C91.8342 39.023 91.699 39.4408 91.6076 39.8712C91.5628 40.2026 91.6076 40.5307 91.5628 40.8691C91.4124 41.7206 90.9676 42.4952 90.702 43.3292Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M92.5852 40.3875C92.3395 40.4886 92.1246 40.6629 91.9651 40.8905C91.8056 41.1181 91.7078 41.3899 91.6828 41.6751C91.2058 41.34 90.851 40.8337 90.6799 40.2438C90.5087 39.6538 90.5318 39.0172 90.7452 38.4438C91.4844 36.3502 92.486 33.3807 95.4684 33.8133C98.4508 34.246 104.704 35.2091 102.464 42.4741C100.224 49.7392 98.0028 40.8655 98.0028 40.8655L92.5852 40.3875Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M99.1094 53.965C96.3926 53.7801 97.5446 51.2258 97.6694 50.2802C97.7025 49.8677 97.6199 49.454 97.4326 49.0938C97.3061 48.8262 97.1514 48.5756 96.9718 48.347C95.7814 48.347 94.463 48.1725 93.519 47.3002C92.463 46.3406 92.0438 44.5505 91.871 43.1303C91.7355 41.8165 91.7119 40.4918 91.8006 39.1733C91.8006 38.9779 91.8262 38.7859 91.8326 38.594C91.8742 37.8368 91.919 37.0831 91.9446 36.3433C91.9446 36.3433 94.5782 35.7117 96.9302 36.298C98.671 36.7307 99.8934 38.3079 100.421 40.7889C100.616 41.7338 100.714 42.6993 100.713 43.6677C100.761 47.7922 102.242 48.5145 102.821 49.7253C103.401 50.9362 101.833 54.1395 99.1094 53.965Z",
    fill: "#DCACFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M94.2542 44.0278L93.6142 41.3723L93.1758 44.1639C93.1758 44.1639 93.531 44.4814 94.2542 44.0278Z",
    fill: "#AF7ED1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M96.1365 44.48C96.1365 44.48 95.7365 45.4152 94.4629 45.5792",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M96.0037 39.9862C95.83 39.7778 95.6019 39.6326 95.35 39.5702C95.0982 39.5078 94.8349 39.5312 94.5957 39.6373",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M94.9924 41.2856C95.0148 41.5543 95.1588 41.7602 95.3124 41.7462C95.466 41.7323 95.5748 41.502 95.5556 41.2333C95.5364 40.9646 95.3892 40.7587 95.2356 40.7727C95.082 40.7866 94.9732 41.0169 94.9924 41.2856Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M92.1621 42.0452C92.1845 42.3139 92.3285 42.5198 92.4821 42.5058C92.6357 42.4919 92.7445 42.2616 92.7253 41.9929C92.7061 41.7242 92.5589 41.5148 92.4053 41.5323C92.2517 41.5497 92.1621 41.7765 92.1621 42.0452Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M91.7539 38.6386C92.7802 38.3829 93.744 37.8889 94.5795 37.1905C95.5203 40.5822 99.5267 40.7044 100.528 40.7044C100.004 38.2234 98.7427 36.4996 97.0083 36.0669C94.6595 35.4807 91.8883 36.1576 91.8883 36.1576C91.8627 36.9009 91.7923 37.8849 91.7539 38.6386Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M95.2361 40.7668L94.5801 40.6308C94.5801 40.6308 94.7497 41.1507 95.2361 40.7668Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M92.5369 41.5491L91.8809 41.4165C91.8809 41.4165 92.0505 41.9329 92.5369 41.5491Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M101.197 34.3609C101.523 32.8866 100.637 31.3886 99.218 31.0151C97.799 30.6416 96.384 31.534 96.0577 33.0084C95.7314 34.4827 96.6172 35.9807 98.0362 36.3542C99.4553 36.7277 100.87 35.8353 101.197 34.3609Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M93.7207 37.6886L93.1895 38.4492C93.1895 38.4492 94.5943 38.1841 94.9047 37.1372C95.2151 36.0904 94.0439 36.9104 94.0439 36.9104L93.7207 37.6886Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    opacity: 0.1,
    d: "M98.7659 47.5171C98.4219 48.1345 97.9682 48.6707 97.4315 49.0943C97.3049 48.8268 97.1503 48.5762 96.9707 48.3476C97.6038 48.1701 98.2089 47.8902 98.7659 47.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M91.5605 40.8514C91.6336 40.6031 91.7848 40.391 91.9874 40.2524C92.19 40.1139 92.4309 40.0578 92.6677 40.0942",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M99.7089 41.1283C99.7964 40.9858 99.8961 40.8526 100.006 40.7305C100.381 40.3152 100.992 39.7709 101.558 40.0745C102.243 40.4234 102.099 41.4877 101.907 42.1298C101.753 42.7044 101.399 43.1911 100.922 43.4872C100.246 43.8675 99.2417 43.6651 99.2481 42.6741C99.2588 42.1206 99.4191 41.5829 99.7089 41.1283Z",
    fill: "#DCACFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M100.423 39.9932C100.423 39.9932 99.3034 42.052 99.761 43.8735C100.219 45.695 99.9658 46.5534 99.649 47.52C99.649 47.52 99.7738 44.7528 99.249 43.7548C98.449 42.23 99.569 39.9863 99.569 39.9863L100.423 39.9932Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M96.0938 33.8468C96.0938 33.8468 98.9929 34.2236 100.737 35.5217C100.737 35.5042 99.2233 33.3094 96.0938 33.8468Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M60.3028 74.8536H78.5428C78.728 74.8537 78.9108 74.8078 79.0774 74.7194C79.2439 74.631 79.3898 74.5023 79.5039 74.3432C79.6181 74.1841 79.6975 73.9987 79.7361 73.8012C79.7747 73.6036 79.7715 73.3991 79.7268 73.2031L76.482 59.1022C76.4162 58.8141 76.2639 58.5583 76.0493 58.3755C75.8348 58.1927 75.5702 58.0936 75.298 58.0938H57.058C56.8727 58.0936 56.6899 58.1395 56.5233 58.2279C56.3568 58.3164 56.2109 58.445 56.0968 58.6041C55.9827 58.7632 55.9033 58.9486 55.8647 59.1462C55.8261 59.3437 55.8292 59.5483 55.874 59.7443L59.0996 73.8451C59.1661 74.1368 59.3212 74.3952 59.5397 74.5783C59.7583 74.7615 60.0272 74.8585 60.3028 74.8536Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M90.31 74.8031H77.9132V73.7563H89.6764C89.8461 73.7563 90.0089 73.8298 90.129 73.9607C90.249 74.0915 90.3164 74.269 90.3164 74.4541V74.824L90.31 74.8031Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    opacity: 0.3,
    d: "M60.3028 74.8536H78.5428C78.728 74.8537 78.9108 74.8078 79.0774 74.7194C79.2439 74.631 79.3898 74.5023 79.5039 74.3432C79.6181 74.1841 79.6975 73.9987 79.7361 73.8012C79.7747 73.6036 79.7715 73.3991 79.7268 73.2031L76.482 59.1022C76.4162 58.8141 76.2639 58.5583 76.0493 58.3755C75.8348 58.1927 75.5702 58.0936 75.298 58.0938H57.058C56.8727 58.0936 56.6899 58.1395 56.5233 58.2279C56.3568 58.3164 56.2109 58.445 56.0968 58.6041C55.9827 58.7632 55.9033 58.9486 55.8647 59.1462C55.8261 59.3437 55.8292 59.5483 55.874 59.7443L59.0996 73.8451C59.1661 74.1368 59.3212 74.3952 59.5397 74.5783C59.7583 74.7615 60.0272 74.8585 60.3028 74.8536Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M59.347 74.8536H77.587C77.7722 74.8537 77.9551 74.8078 78.1216 74.7194C78.2881 74.631 78.434 74.5023 78.5482 74.3432C78.6623 74.1841 78.7417 73.9987 78.7803 73.8012C78.8189 73.6036 78.8157 73.3991 78.771 73.2031L75.523 59.1022C75.4572 58.8141 75.3049 58.5583 75.0903 58.3755C74.8758 58.1927 74.6113 58.0936 74.339 58.0938H56.099C55.9137 58.0936 55.7309 58.1395 55.5644 58.2279C55.3978 58.3164 55.2519 58.445 55.1378 58.6041C55.0237 58.7632 54.9443 58.9486 54.9057 59.1462C54.8671 59.3437 54.8703 59.5483 54.915 59.7443L58.1406 73.8451C58.2077 74.137 58.3635 74.3956 58.5826 74.5787C58.8016 74.7618 59.071 74.8587 59.347 74.8536Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    opacity: 0.2,
    d: "M59.347 74.8536H77.587C77.7722 74.8537 77.9551 74.8078 78.1216 74.7194C78.2881 74.631 78.434 74.5023 78.5482 74.3432C78.6623 74.1841 78.7417 73.9987 78.7803 73.8012C78.8189 73.6036 78.8157 73.3991 78.771 73.2031L75.523 59.1022C75.4572 58.8141 75.3049 58.5583 75.0903 58.3755C74.8758 58.1927 74.6113 58.0936 74.339 58.0938H56.099C55.9137 58.0936 55.7309 58.1395 55.5644 58.2279C55.3978 58.3164 55.2519 58.445 55.1378 58.6041C55.0237 58.7632 54.9443 58.9486 54.9057 59.1462C54.8671 59.3437 54.8703 59.5483 54.915 59.7443L58.1406 73.8451C58.2077 74.137 58.3635 74.3956 58.5826 74.5787C58.8016 74.7618 59.071 74.8587 59.347 74.8536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    opacity: 0.3,
    d: "M67.6532 66.065C67.906 67.241 67.3972 68.382 66.514 68.6088C65.6308 68.8356 64.7028 68.068 64.4468 66.892C64.1908 65.7161 64.7028 64.575 65.586 64.3482C66.4692 64.1214 67.3972 64.9065 67.6532 66.065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M54.922 76.0799L48.1924 121.589H46.7012L53.4692 75.8217L54.922 76.0799Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    opacity: 0.5,
    d: "M54.922 76.0799L48.1924 121.589H46.7012L53.4692 75.8217L54.922 76.0799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M64.823 121.591H63.3286L56.8262 76.0782L58.2822 75.8305L64.823 121.591Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    opacity: 0.5,
    d: "M64.823 121.591H63.3286L56.8262 76.0782L58.2822 75.8305L64.823 121.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M80.349 76.0799L73.6194 121.589H72.125L78.893 75.8217L80.349 76.0799Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    opacity: 0.5,
    d: "M80.349 76.0799L73.6194 121.589H72.125L78.893 75.8217L80.349 76.0799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M102.809 121.591H101.318L94.8125 76.0782L96.2685 75.8305L102.809 121.591Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    opacity: 0.5,
    d: "M102.809 121.591H101.318L94.8125 76.0782L96.2685 75.8305L102.809 121.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M104.643 74.5238H42.8027V76.6419H104.643V74.5238Z",
    fill: "#0060C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    opacity: 0.3,
    d: "M104.671 74.5238H79.7461V76.6419H104.671V74.5238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M102.423 74.527H92.209C92.209 74.3622 92.269 74.2042 92.3758 74.0878C92.4826 73.9713 92.6275 73.9058 92.7786 73.9058H101.851C102.002 73.9058 102.147 73.9712 102.254 74.0876C102.362 74.2039 102.423 74.3619 102.423 74.527Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M98.7172 68.5894L97.3412 72.1905C97.0884 72.1347 96.8612 72.0963 96.7012 72.0719L98.1348 68.3207C98.1675 68.2351 98.23 68.1672 98.3086 68.1318C98.3872 68.0965 98.4755 68.0966 98.554 68.1323C98.6325 68.1679 98.6948 68.2361 98.7272 68.3218C98.7596 68.4075 98.7595 68.5038 98.7268 68.5894H98.7172Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M99.6883 65.7692C101.456 65.7692 102.888 63.9601 102.888 61.7284C102.888 59.4968 101.456 57.6877 99.6883 57.6877C97.921 57.6877 96.4883 59.4968 96.4883 61.7284C96.4883 63.9601 97.921 65.7692 99.6883 65.7692Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M106.764 60.4936L106.547 59.6526L111.446 56.9902L111.612 57.9986L106.764 60.4936Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    opacity: 0.1,
    d: "M106.547 59.6449L105.062 57.2197L107.421 63.2286L106.547 59.6449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M93.2112 62.4002L93.0768 61.4895L91 60.6276V61.4895L93.2112 62.4002Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    opacity: 0.1,
    d: "M93.2106 62.4019C93.169 62.2274 92.6602 58.4204 92.6602 58.4204V62.1751L93.2106 62.4019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M97.3462 50.9259C97.3462 50.9259 95.9446 54.3385 99.247 54.2304C102.549 54.1222 103.381 51.4632 103.548 49.4847L102.517 49.0974C102.517 49.0974 101.922 51.8889 99.6886 52.4438C97.455 52.9986 97.6406 50.4583 97.6406 50.4583L97.3462 50.9259Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    opacity: 0.1,
    d: "M78.582 119.372L82.0668 120.265L82.2652 119.313L78.7836 118.535L78.582 119.372Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRafiki);
export default __webpack_public_path__ + "static/media/rafiki.5718ea6006fa238710b193d92120278e.svg";
export { ForwardRef as ReactComponent };